import { ExtraAssetOption } from '@hb/domain';
import { ExtraAssetStoreService } from '@hb/modules/extra-asset/extra-asset-store.service';
import content from '@hb/hypotheken-berekening.content.json';
import { OwnMoneyPartComponent } from '@hb/modules/extra-asset/own-money-part/own-money-part.component';
import { OwnPropertyPartComponent } from '@hb/modules/extra-asset/own-property-part/own-property-part.component';

import { ReactiveFormsModule } from '@angular/forms';
import { Component, inject, OnInit } from '@angular/core';

import { ApContentModule, ApContentService } from '@ap/content';

@Component({
    selector: 'ap-extra-asset',
    templateUrl: './extra-asset.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, OwnPropertyPartComponent, OwnMoneyPartComponent]
})
export class ExtraAssetComponent implements OnInit {
    protected readonly store = inject(ExtraAssetStoreService);
    protected readonly contentService = inject(ApContentService);

    protected readonly options = ExtraAssetOption;

    activeOption: ExtraAssetOption;

    ngOnInit(): void {
        this.contentService.addContentItems(content);

        this.store.getActiveOption().subscribe((question) => {
            this.activeOption = question;
        });
    }
}
